import { memo } from 'react';

const Page404 = (): JSX.Element => {
  return <h1>Page not found</h1>;
};

export default memo(Page404);
